import Vue from 'vue';
import App from './app.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import '@/asset/js/rem';
import wx from '@/util/wx';

Vue.config.productionTip = false;
axios.defaults.withCredentials = true;
Vue.prototype.$axios = axios;

wx.init();
Vue.prototype.$wx = wx;

const attachFastClick = require('fastclick');
attachFastClick.prototype.focus = (targetElement: any) => {
  targetElement.focus();
};
attachFastClick.attach(document.body);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
